import cc from 'classcat';

import {
  selectContentType,
  selectFields,
} from '../../lib/contentful/selectors';
import Button from '../Button';
import UpcomingGameButton from '../UpcomingGameButton';
import FormatRelative from '../FormatRelative';

import styles from './styles.module.scss';

const CtaButton = ({
  theme,
  cta,
  className,
  subtextClassName,
  ...buttonProps
}) => {
  const contentTypeId = selectContentType(cta);

  if (contentTypeId == 'gameLink') {
    const { id, label, game = '', theme: ctaTheme } = selectFields(cta);
    const [, subtype] = game.split('-');
    return (
      <UpcomingGameButton
        {...buttonProps}
        theme={ctaTheme || subtype || theme}
        id={id}
        label={label}
        gameToFind={game}
        className={cc([styles.button, className])}
      >
        {(game) =>
          game?.startDate && (
            <FormatRelative
              date={game.startDate}
              className={cc([styles.ctaSubtext, subtextClassName])}
            />
          )
        }
      </UpcomingGameButton>
    );
  }

  return (
    <Button
      {...buttonProps}
      theme={theme}
      link={cta}
      className={cc([styles.button, className])}
    />
  );
};

export default CtaButton;
